import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SiteContext = createContext({});

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);
  return <SiteContext.Provider value={settings}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);
